import React from 'react';
import Price from '../price';
import { TilaProduct } from './tila-modal';

interface TilaReceiptProps {
  product: TilaProduct | undefined;
}

const TilaReceipt: React.FC<TilaReceiptProps> = ({ product }) => {
  if(!product) return null;
  
  for (const key in product.metafields) {
    if (Object.hasOwn(product.metafields, key)) {
      product.metafields[key] = escapeQuotes(product.metafields[key]);
    }
  }

  const {
    'payment-type': paymentType,
    'num-remaining-payments': numRemainingPayments,
    'additional-payments-amount': additionalPaymentsAmount,
    'annual-percent-rate': annualPercentRate,
    'finance-charge': financeCharge,
    'amount-financed': amountFinanced,
    'total-of-payments': totalOfPayments,
    'total-sales-price': totalSalesPrice,
  } = product.metafields;

  const totalPayments = parseFloat(numRemainingPayments) + 1;

  const today = new Date();
  const startDate = new Date(today);
  const endDate = new Date(today.setMonth(today.getMonth() + parseFloat(numRemainingPayments)));

  const startDateString = startDate.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const endDateString = endDate.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <>
      <div className="tila-modal-main-bottom-part-table">
        <div className="tila-modal-main-bottom-part-table-column">
          <div className="tila-modal-main-bottom-part-table-column-header">Annual % Rate*</div>
          <div className="tila-modal-main-bottom-part-table-column-info">
            The cost of your credit as a yearly rate.
          </div>
          <div className="tila-modal-main-bottom-part-table-column-footer">
            {annualPercentRate}%
          </div>
        </div>

        <div className="tila-modal-main-bottom-part-table-column">
          <div className="tila-modal-main-bottom-part-table-column-header">Finance Charge</div>
          <div className="tila-modal-main-bottom-part-table-column-info">
            The dollar amount the credit will cost you.
          </div>
          <div className="tila-modal-main-bottom-part-table-column-footer">
            <Price amount={financeCharge} currencyCode='USD'/>
          </div>
        </div>

        <div className="tila-modal-main-bottom-part-table-column">
          <div className="tila-modal-main-bottom-part-table-column-header">Amount Financed</div>
          <div className="tila-modal-main-bottom-part-table-column-info">
            The amount of credit provided to you or on your behalf.
          </div>
          <div className="tila-modal-main-bottom-part-table-column-footer">
            <Price amount={amountFinanced} currencyCode='USD'/>
          </div>
        </div>

        <div className="tila-modal-main-bottom-part-table-column">
          <div className="tila-modal-main-bottom-part-table-column-header">Total of Payments</div>
          <div className="tila-modal-main-bottom-part-table-column-info">
            The amount you will have paid after you have made all payments as scheduled.
          </div>
          <div className="tila-modal-main-bottom-part-table-column-footer">
            <Price amount={totalOfPayments} currencyCode='USD'/>
          </div>
        </div>

        <div className="tila-modal-main-bottom-part-table-column">
          <div className="tila-modal-main-bottom-part-table-column-header">Total Sales Price</div>
          <div className="tila-modal-main-bottom-part-table-column-info">
            The total cost of your purchase on credit, including your down payment of <Price amount={additionalPaymentsAmount} currencyCode='USD'/>.
          </div>
          <div className="tila-modal-main-bottom-part-table-column-footer">
            <Price amount={totalSalesPrice} currencyCode='USD'/>
          </div>
        </div>
      </div>

      <h4 className="tila-modal-main-bottom-part-info-heading">Payment Schedule:</h4>
      <p>
        I agree to make {totalPayments} monthly payments of <Price amount={additionalPaymentsAmount} currencyCode='USD'/>, starting{' '}
        {startDateString} and ending {endDateString}, unless modified and recalculated due to off-schedule or partial payments. Total amount due will not increase due to off-schedule payments.
      </p>

      <h4 className="tila-modal-main-bottom-part-info-heading">Same-as-Cash Prepayment Option:</h4>
      <p>
        During the next {totalPayments} months, I can get &quot;same as cash&quot; pricing (0% APR) by contacting 4Patriots and paying the &apos;full pay&apos; sales price in full (credit applied for payments made). 

      </p>
    </>
  );
};

export default TilaReceipt;

const escapeQuotes = (str: any) => {
  if (typeof str === 'string' && str.startsWith('"') && str.endsWith('"')) {
    return str.substring(1, str.length - 1);
  }
  return str;
};
